import React, { Component } from 'react';
import ApiService from "../service/ApiService";


class OffresComponent extends Component {

    constructor(props) {
        super(props)
        this.state = {
            offres : [],
            message : "",
            loading : false,
            successful : false,
            primeNetteLibre : 0
        }
        this.loadOffres = this.loadOffres.bind(this);
        this.handleGarChange = this.handleGarChange.bind(this);
        this.handleGarChange2 = this.handleGarChange2.bind(this);
        this.va = this.va.bind(this);
       
    }

    componentDidMount() {
        this.loadOffres();
    }

    loadOffres() {
        this.setState({loading: true});

        let risque = {
            dateMEC: this.props.dateMEC ? this.props.dateMEC.toLocaleDateString("fr-FR") : null, 
            dateNaissance: this.props.dateNaissance ? this.props.dateNaissance.toLocaleDateString("fr-FR") : null, 
            puissanceFiscale: this.props.puissanceFiscale, 
            datePermis: this.props.datePermis ? this.props.datePermis.toLocaleDateString("fr-FR") : null, 
            villeClient: this.props.villeClient,
            usage: this.props.usage,
            lob : this.props.lob,
            energie : this.props.energie,
            valeurNeuf : this.props.valeurNeuf ,
            valeurVenale : this.props.valeurVenale,
            valeurGlaces : this.props.valeurGlaces,
            nombreSinistres : this.props.nombreSinistres,
        };

        ApiService.fetchOffres(risque)
            .then(res => {
                let isErr = res.data.errorMessage ? true : false;
                if (!isErr) {
                    let offresTriees = res.data.result.offres.slice();
                    let index = 0;
                    for (index = 0; index < offresTriees.length; index++) { 
                        offresTriees[index].garanties.sort((a,b)=>{ return a.ordre-b.ordre;});
                    }
                    offresTriees.sort((a,b)=>{ return a.ordre-b.ordre;}); 
                    this.setState({
                        loading : false, 
                        message : res.data.message,
                        offres : offresTriees,
                        isSuccess: true
                    });
                 } else {
                    this.setState({message: res.data.errorMessage});
                    this.setState({isSuccess: false});
                    this.setState({loading: false});
                 }
            }).catch(error => {
                //console.log(error);
                this.setState({
                    loading : false, 
                    message : error.message,
                    isSuccess: false
                });
            })
    }

    handleGarChange(e) {
        let ename =  e.target.name;
        let checked =  e.target.checked; 
        ApiService.fetchPrimeByGarUsage(this.props.usage, e.target.name, this.va(ename))
        .then(res => {
            let isErr = res.data.errorMessage ? true : false;
            if (!isErr) {
                let prime = res.data.result;
                let primeNetteLibreT = this.state.primeNetteLibre;
                if (checked) {
                    primeNetteLibreT = primeNetteLibreT + prime;
                }
                else {
                    primeNetteLibreT = primeNetteLibreT - prime;
                }
                this.setState({
                    primeNetteLibre : primeNetteLibreT
                });
             } else {
                this.setState({message: res.data.errorMessage});
                this.setState({isSuccess: false});
             }
        }).catch(error => {
            //console.log(error);
            this.setState({ 
                message : error.message
            });
        })
        this.setState({ [ename]: checked });

        
    }

    handleGarChange2(position, io) {
        let ename =  this.state.offres[io].garanties[position].code;
        let checked =  !this.state.offres[io].garanties[position].checked; 
        let nouvellesOffres = this.state.offres.slice();
        ApiService.fetchPrimeByGarUsage(this.props.usage, ename, this.va(ename))
        .then(res => {
            let isErr = res.data.errorMessage ? true : false;
            if (!isErr) {
                let prime = res.data.result;
                let primeNetteLibreT = this.state.offres[io].primeNette;
                if (checked) {
                    primeNetteLibreT = primeNetteLibreT + prime;
                }
                else {
                    primeNetteLibreT = primeNetteLibreT - prime;
                }
                nouvellesOffres[io].primeNette = primeNetteLibreT;
                nouvellesOffres[io].garanties[position].checked = checked;
                this.setState({ offres : nouvellesOffres });
 
             } else {
                this.setState({message: res.data.errorMessage});
                this.setState({isSuccess: false});
             }
        }).catch(error => {
            //console.log(error);
            this.setState({ 
                message : error.message,
                isSuccess: false
            });
        })

        
    }

    va  = (codeGar) => {
        if (codeGar === 'T') {
            return this.props.valeurNeuf;
        }
        else {
            if (codeGar === 'BDG') {
                return this.props.valeurGlaces;
            }
            else {
                return this.props.valeurVenale;
            }
        }

    }

    selectOffre  = (io) => {

        let offresTemp  = this.state.offres.slice();
        let index = 0;
        for (index = 0; index < offresTemp.length; index++) {
            offresTemp[index].selected = false;
        }
        offresTemp[io].selected = true;

        let offreSelectionnee = offresTemp.slice(io,io+1);
        let risque = {
            dateMEC: this.props.dateMEC ? this.props.dateMEC.toLocaleDateString("fr-FR") : null, 
            dateNaissance: this.props.dateNaissance ? this.props.dateNaissance.toLocaleDateString("fr-FR") : null, 
            puissanceFiscale: this.props.puissanceFiscale, 
            datePermis: this.props.datePermis ? this.props.datePermis.toLocaleDateString("fr-FR") : null, 
            villeClient: this.props.villeClient,
            usage: this.props.usage,
            lob : this.props.lob,
            energie : this.props.energie,
            valeurNeuf : this.props.valeurNeuf ,
            valeurVenale : this.props.valeurVenale,
            valeurGlaces : this.props.valeurGlaces,
            nombreSinistres : this.props.nombreSinistres,
            offres : offreSelectionnee
        };
        window.localStorage.removeItem("risqueGar");
        window.localStorage.setItem("risqueGar", JSON.stringify(risque));

        this.setState({ 
            offres : offresTemp
        });

    }
    

    render() {

        return (
            <React.Fragment>
            {this.state.loading && ( 
            <div class="text-center container mb-4 mt-4">
            <div class="spinner-border text-danger" style={{"width": "4rem", "height": "4rem"}} role="status">
                <span class="sr-only">Chargement en cours...</span>
            </div>  
        </div>
            )}
            {!this.state.loading && (
                <div class="container mb-4 mt-4">
                  <div
                    className={
                      this.state.isSuccess
                        ? "alert alert-success alert-dismissible fade show"
                        : "alert alert-danger alert-dismissible fade show"
                    }
                    style = {{'white-space': 'pre-wrap'}}
  
                    role="alert"
                  >
                    {this.state.isSuccess ? <strong>OK! </strong> : <strong>KO! </strong> }
                    {this.state.message}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              )}
              {!this.state.loading && this.state.isSuccess && (
              <div class="container mb-4 mt-4">
              <div class="pricing card-deck flex-column flex-md-row mb-2 py-3">
              {   this.state.offres.map((offre,io) => (
                  <div class="card card-pricing shadow px-3 mb-4" key = {offre.libelle}>
                      <span class="h6 w-60 mx-auto px-4 py-1 rounded-bottom bg-primary text-white shadow-sm">{offre.libelle}</span>
                      <div class="bg-transparent card-header pt-4 border-0">
                          <h1 class="h4 font-weight-normal text-primary text-center mb-0"><span class="h6 text-muted">DH </span> <span class="price">{offre.primeNette}</span><span class="h6 text-muted ml-2"> Nette / année</span></h1>
                      </div>
                      <div class="card-body pt-0">
                          {!offre.libre &&
                          <ul class="fa-ul mb-4">
                         { offre.garanties.map(garantie => (
                            <li key = {garantie.code}><span class="fa-li"><i class={garantie.checked ? "fa fa-fw fa-check text-success" : "fa fa-fw fa-times"}></i></span>{garantie.libelle}</li>
                            ))}
                            </ul>
                            }
                            {offre.libre &&
                          <form >
                         { offre.garanties.map((garantie,index) => (
                            <div class="custom-control custom-checkbox" key = {garantie.code}>
                            <input class="custom-control-input" type="checkbox" id={garantie.code} name={garantie.code} checked={this.state.offres[io].garanties[index].checked} onChange={() => this.handleGarChange2(index,io)} disabled = {garantie.code === "RC"} />
                            <label class="custom-control-label" for={garantie.code}>
                                    {garantie.libelle}
                            </label>
                            </div>
                            ))}
                            </form>
                            }
                        <div class="bg-transparent card-footer pt-4 border-0 text-center">
                            <div className='custom-control custom-switch'>
                                <input
                                type='checkbox'
                                className='custom-control-input'
                                id={offre.libelle}
                                checked={this.state.offres[io].selected} onChange={() => this.selectOffre(io)}
                                />
                                <label className='custom-control-label' htmlFor={offre.libelle}>
                                Choisir cette Offre
                                </label>
                            </div>
                        </div>
                      </div>
                  </div>
                    ))}
      

 
              </div>
            </div>
            )}
                 
          </React.Fragment>
        

        );
    }

}


export default OffresComponent;